export default __webpack_public_path__ + "static/content-types-772cba4412b8cfe8d5698d7fd9aba3ce.gif";